export default __webpack_public_path__ + "static/media/6a28ee3f0f489d826a65f0091d107ec9.svg";